import UI from "./UI";

interface RetailersListProps {
  content: any[] | undefined;
  filter: {
    key: string;
    value: string;
  };
}

// Plain codepoint comparison rather than localeCompare: ICU tables differ
// between Node and the browser, and any disagreement is a hydration mismatch.
const compare = (a: string, b: string) => (a < b ? -1 : a > b ? 1 : 0);

const sortKey = (value: unknown) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const RetailersList = ({ content, filter }: RetailersListProps) => {
  const filtered =
    filter.value === "all"
      ? content
      : content?.filter((story) => {
          return (
            filter.key in story.content &&
            story.content[filter.key] == filter.value
          );
        });

  // Copy before sorting: when the filter is "all" this array is the caller's
  // state, and sorting in place would reorder it on every render.
  const sorted = filtered
    ?.slice()
    .sort(
      (a, b) =>
        compare(sortKey(a?.content?.country), sortKey(b?.content?.country)) ||
        compare(
          sortKey(a?.content?.name ?? a?.name),
          sortKey(b?.content?.name ?? b?.name)
        )
    );

  return <UI content={sorted} />;
};

export default RetailersList;
